/*
/*
 * @创建文件时间: 2019-11-10 11:24:29
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2021-09-27 15:52:09
 * @联系Qq:1638245306
 * @文件介绍:
 */
export default [{
    path: 'sysRole',
    name: 'sysRole',
    meta: {
        title: '角色管理',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/sysRole')
}, {
    path: 'sysOrganize',
    name: 'sysOrganize',
    meta: {
        title: '组织机构管理',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/sysOrganize')
}, {
    path: 'sysPermission',
    name: 'sysPermission',
    meta: {
        title: 'PC菜单管理',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/sysPermission')
}, {
    path: 'sysPermissionApp',
    name: 'sysPermissionApp',
    meta: {
        title: 'APP菜单管理',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/sysPermissionApp')
}, {
    path: 'sysUser',
    name: 'sysUser',
    meta: {
        title: '用户管理',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/sysUser')
}, {
    path: 'sysDictionaries',
    name: 'sysDictionaries',
    meta: {
        title: '字典管理',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/sysDictionaries')
},
{
    path: 'sysWorkloadListDictionaries',
    name: 'sysWorkloadListDictionaries',
    meta: {
        title: ' 工程量清单字典管理',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/sysWorkDictionaries')
}, {
    path: 'sysWorkDictionaries',
    name: 'sysWorkDictionaries',
    meta: {
        title: ' 工程量清单字典管理',//树形
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/sysWorkDictionaries')
}, {
    path: 'test',
    name: 'test',
    meta: {
        title: ' 上传测试',
        auth: true
    },
    component: () =>
        import('@/views/Test/index')
}, {
    path: 'pageTest',
    name: 'pageTest',
    meta: {
        title: ' pagebodytest',
        auth: true
    },
    component: () =>
        import('@/views/Test/PageTest')
}, {
    path: 'imageTest',
    name: 'imageTest',
    meta: {
        title: ' 图片测试',
        auth: true
    },
    component: () =>
        import('@/views/Test/imageTest')
}, {
    path: 'noticeIssued',
    name: 'noticeIssued',
    meta: {
        title: '通知管理',
        auth: true
    },
    component: () =>
        //import ('@/views/system/controllers/healthInspection/noticeIssued')
        import('@/views/system/controllers/notices/IssuedNotice')
}, {
    path: 'inbox',
    name: 'inbox',
    meta: {
        title: '通知管理',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/notices/Inbox')
}, {
    path: 'alarmManagement',
    name: 'alarmManagement',
    meta: {
        title: '告警管理',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/healthInspection/alarmManagement')
}, {
    path: 'sysFeedBack',
    name: 'sysFeedBack',
    meta: {
        title: '意见反馈',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/sysFeedBack')
}, {
    path: 'mqiSParameter',
    name: 'mqiSParameter',
    meta: {
        title: '构造物评定参数表',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/mqiSParameter')
}, {
    path: 'bridgeTunnelCulvertDict',
    name: 'bridgeTunnelCulvertDict',
    meta: {
        title: '桥隧涵字典管理',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/dict/bridgeTunnelCulvertDict')
}, {
    path: 'diseaseDict',
    name: 'diseaseDict',
    meta: {
        title: '日常养护作业项目库',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/dict/diseaseDict')
}, {
    path: 'workArea',
    name: 'workArea',
    meta: {
        title: '安全布设作业内容',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/dict/workArea')
}, {
    path: 'dailyWorkContentDic',
    name: 'dailyWorkContentDic',
    meta: {
        title: '日常养护巡查工作内容',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/dict/dailyWorkContentDic')
}, {
    path: 'newDictionaryPg',
    name: 'newDictionaryPg',
    meta: {
        title: '综合数据字典管理',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/dict/newDictionaryPg')
}, 
{
    path: 'newDictionaryPgNew',
    name: 'newDictionaryPgNew',
    meta: {
        title: '综合数据字典管理（新）',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/dict/newDictionaryPgNew')
}, 
{
    path: 'examineDictionaryNew',
    name: 'examineDictionaryNew',
    meta: {
        title: '综合数据字典管理审核（新）',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/dict/examineDictionaryNew')
}, 
{
    path: 'examineDictionary',
    name: 'examineDictionary',
    meta: {
        title: '综合数据字典管理（新审核）',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/dict/examineDictionary')
}, 
{
    path: 'helpCenter',
    name: 'helpCenter',
    meta: {
        title: '帮助中心',
        auth: true
    },
    component: () =>
        import('@/views/system/helpCenter/helpCenter')
},
{
    path: 'newDict',
    name: 'newDict',
    meta: {
        title: '字典管理',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/newDict/index')
},
{
    path: 'applyDict',
    name: 'applyDict',
    meta: {
        title: '字典申请',
        auth: true
    },
    component: () =>
        import('@/views/system/controllers/newDict/applyDict.vue')
}
]
